import disonaAppIcon from 'themes/disonaTheme/icons/common/disona-logo.png';
import rockWestAppIcon from '../assets/icons/common/rock-west/fresh-chat-rw-icon.png';

const FRESHCHAT_HEADERS = {
  chat: 'Chat with Us',
  chat_help: 'Reach out to us if you have any questions',
  faq: 'Solution Articles',
  faq_help: 'Browse our articles',
  faq_not_available: 'No Articles Found',
  faq_search_not_available: 'No articles were found for {{query}}',
  faq_useful: 'Was this article helpful?',
  faq_thankyou: 'Thank you for your feedback',
  faq_message_us: 'Message Us',
  push_notification: "Don't miss out on any replies! Allow push notifications?",
  csat_question: 'Did we address your concerns??',
  csat_yes_question: 'How would you rate this interaction?',
  csat_no_question: 'How could we have helped better?',
  csat_thankyou: 'Thanks for the response',
  csat_rate_here: 'Submit your rating here',
  channel_response: {
    offline: 'We are currently away. Please leave us a message',
    online: {
      minutes: {
        one: 'Currently replying in {!time!} minutes ',
        more: 'Typically replies in {!time!} minutes',
      },
      hours: {
        one: 'Currently replying in under an hour',
        more: 'Typically replies in {!time!} hours',
      },
    },
  },
};

const FRESHCHAT_COMMON_CONFIG = {
  disableEvents: true,
  cssNames: {
    widget: 'fc_frame',
    open: 'fc_open',
    expanded: 'fc_expanded',
  },
  showFAQOnOpen: false,
  hideFAQ: true,
  agent: {
    hideName: false,
    hidePic: false,
    hideBio: false,
  },
  content: {
    placeholders: {
      search_field: 'Search',
      reply_field: 'Reply',
      csat_reply: 'Add your comments here',
    },
    actions: {
      csat_yes: 'Yes',
      csat_no: 'No',
      push_notify_yes: 'Yes',
      push_notify_no: 'No',
      tab_faq: 'Solutions',
      tab_chat: 'Chat',
      csat_submit: 'Submit',
    },
  },
};

export const ROCK_WEST_FRESHCHAT_CONFIG = {
  ...FRESHCHAT_COMMON_CONFIG,
  headerProperty: {
    appName: 'Rock-west',
    appLogo: rockWestAppIcon,
    backgroundColor: '#2d9cdb',
    foregroundColor: '#fff',
  },
};

export const DISONA_FRESHCHAT_CONFIG = {
  ...FRESHCHAT_COMMON_CONFIG,
  token: '62319273-e126-4903-9a32-ef74e891f04d',
  host: 'https://tempo-remit.freshchat.com',
  widgetUuid: '20bd8dc2-4aff-4f86-a141-83178fcb2e5c',
  locale: 'en',
  tags: ['disona'],
  headerProperty: {
    appName: 'Disona',
    appLogo: disonaAppIcon,
    backgroundColor: '#fff',
    foregroundColor: '#003765',
  },
};
